<script>
import Layout from '@layouts/auth.vue'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      username: null,
      password: null,
      authError: null,
      tryingToLogIn: false,
    }
  },
  computed: {},
  beforeCreate() {
    setTimeout(() => {
      console.log(this.$router.app.$children)
      var d = []
      for (var vm of this.$router.app.$children[0].$children) {
        if (vm._inactive === true) d.push(vm)
      }
      for (var _vm of d) {
        window.console.info('Found cached component.')
        _vm.$destroy();
        window.console.info('Cached component destroyed.')
      }
    })
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null
      return this.logIn({
        username: this.username,
        password: this.password,
      })
        .then((token) => {
          this.tryingToLogIn = false

          // Redirect to the originally requested page, or to the home page
          this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
        })
        .catch((error) => {
          console.log(error)
          this.tryingToLogIn = false
          this.authError = error
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="text-center">
      <img src="@assets/images/ldcs.svg" style="width: 120px" />
      <h1 class="h2">Welcome Back &#x1f44b;</h1>
      <p class="">Log in with your L-DCS Insight account to continue</p>
      <form :class="$style.form" @submit.prevent="tryToLogIn">
        <div v-if="authError" class="alert alert-danger" role="alert">
          Username or password not accepted
        </div>
        <div class="form-group">
          <input
            v-model="username"
            class="form-control"
            type="text"
            placeholder="Username"
            name="login-email"
          />
        </div>
        <div class="form-group">
          <input
            v-model="password"
            class="form-control"
            type="password"
            placeholder="Password"
            name="login-password"
          />
          <!-- <div class="text-right">
            <small><a href="#">Forgot password?</a> </small>
          </div> -->
        </div>
        <button
          class="btn btn-lg btn-block btn-primary"
          role="button"
          type="submit"
          :disabled="tryingToLogIn"
        >
          {{ tryingToLogIn ? 'Logging in...' : 'Log in' }}
        </button>
        <!-- <small>Don't have an account yet? <a href="#">Create one</a> </small> -->
      </form>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.form {
  text-align: center;
}
</style>
